module.exports = __webpack_public_path__ + "static/media/burger.e39587b0.PNG";